const previewVideos = {
  corporate: new URL("../../assets/corporate.mp4", import.meta.url).href,
  "povesti-brand": new URL("../../assets/povesti-de-brand.mp4", import.meta.url)
    .href,
  "demo-produs": new URL("../../assets/demo-produs.mp4", import.meta.url).href,
  "social-first": new URL("../../assets/social-first.mp4", import.meta.url)
    .href,
  "fotografie-produs": new URL(
    "../../assets/fotografie-produs.mp4",
    import.meta.url,
  ).href,
  "filmari-on-location": new URL(
    "../../assets/filmari-on-location-2.mp4",
    import.meta.url,
  ).href,
};

export function getPreviewVideoUrl(slug) {
  return previewVideos[slug] || null;
}
